import { useEffect } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata, validateContentFromMetadata } from '@jutro/uiconfig';
import { valueTypeMap, getComponentDataType, getPropDataType } from '../../ScheduleItemsUtil';
import messages from 'gw-components-platform-react/ScheduleItemsComponent/ScheduleItemTypes/SimpleScheduleItem/SimpleScheduleItem.messages';

function formatAvailableValues(availableValues) {
    return _.sortBy(availableValues, 'priority')
        .map((availableValue) => ({
            code: availableValue.code,
            name: availableValue.displayKey
        }));
}

function hasErrors(scheduleItem, value, path, modalData) {
    const isFirstItem = _.isEmpty(scheduleItem.scheduleItems);
    const isValueUnique = scheduleItem.scheduleItems.filter((item) => {
        return item.itemNumber !== modalData.itemNumber;
    })
        .every((item) => {
            const itemValue = _.get(item, path);
            return itemValue !== value;
        });

    return !isValueUnique && !isFirstItem;
}

function getValidationMessage(isUnique, scheduleItem, value, path, modalData, translator) {
    return (isUnique && hasErrors(scheduleItem, value, path, modalData)
        ? [translator(messages.thisFieldMustBeUnique)] : undefined)
        || (value === 0.00 ? [translator(messages.requiredField)] : undefined);
}

export default function SimpleScheduleItem({
    info,
    translator,
    modalData,
    scheduleItem,
    onValueChange,
    onValidate,
    parentOverrides
}) {
    const {
        id,
        valueType,
        required,
        label,
        editable,
        availableTypeListValues = [],
        filteredAvailableTypeListValues = [],
        currency,
        isUnique
    } = info;

    const path = `itemData.${id}.${valueTypeMap[valueType]}`;
    const dataType = getComponentDataType(info);
    const value = _.get(modalData, path);
    const component = dataType == 'boolean' ? 'toggle' : 'input';
    const availableVales = filteredAvailableTypeListValues.length > 0 ? filteredAvailableTypeListValues:availableTypeListValues
    const metadata = dataType !== 'boolean' ? {
        content: [{
            id: id,
            type: 'field',
            datatype: dataType,
            componentProps: {
                dataType: getPropDataType(info),
                required: required,
                availableValues: formatAvailableValues(availableVales),
                currency: currency,
                path: path,
                readOnly: !editable,
                label: label,
                value: value,
                validationMessages: getValidationMessage(
                    isUnique, scheduleItem, value, path, modalData, translator
                ),
                onValueChange: onValueChange,
                searchable: true,
                ...parentOverrides['@field']
            }
        }]
    } : {
        content:[{
            id:id,
            type: 'field',
            component:"Toggle",
            componentProps: {
                availableValues: [
                    {
                        "id": "true",
                        "displayName": "Yes"
                    },
                    {
                        "id": "false",
                        "displayName": "No"
                    }
                ],
                required: required,
                availableValuesCount: "2",
                path: path,
                readOnly: !editable,
                label: label,
                value: value,
                validationMessages: getValidationMessage(
                    isUnique, scheduleItem, value, path, modalData, translator
                ),
                onValueChange: onValueChange,
                ...parentOverrides['@field']
            },
            content: false
        }]
    }
    if(dataType === 'date') {
        metadata.content[0].componentProps['placeholder'] = 'MM/DD/YYYY';
    }
    const isFieldValid = validateContentFromMetadata(metadata);
    useEffect(() => {
        if (onValidate) {
            onValidate(isFieldValid, id);
        }
    }, [onValidate, id, isFieldValid]);

    return renderContentFromMetadata(metadata);
}
